import Link from 'next/link'
import styles from './RecommendedProduct.module.css'

export const RecommendedProduct = ({
    imageLink,
    linkToProduct,
    title,
    price,
}) => {
    return (
        <Link className={styles.recommendedProduct} href={linkToProduct}>
            <div className={styles.container}>
                <img
                    src={imageLink}
                    alt={title}
                    onError={(event) =>
                        (event.currentTarget.src =
                            '/bg/stub-pictures-product.png')
                    }
                />
            </div>
            <div className={styles.text}>
                <h6>{title}</h6>
                <span>{`${Math.ceil(Number(price)).toLocaleString()} ₽`}</span>
            </div>
        </Link>
    )
}
